import DashboardTableSkeleton from '../../components/skelton/DashboardTableSkeleton';
import React from 'react';
import { Table } from 'react-bootstrap';

const DashboardTable = ({ tableBody, tableHeadings, loading, count, appNameShow, tableData, sticky = true }) => {
    console.log("Table headings:", tableHeadings);
    console.log("Table categ", tableData)
    return (
        <>
            {loading ? (
                <DashboardTableSkeleton rowCount={10} columnCount={tableHeadings?.length || 8} />
            ) : tableBody && tableBody?.length > 0 ? (
                <div className="py-3 rounded-3 table-wrapper">
                    <Table hover responsive>
                        <thead>
                            <tr>
                                {tableHeadings?.map((th, idx) => (
                                    <th className={`small table-head text-uppercase ${idx === 0 && sticky ? 'sticky-column' : ''}`} style={{ color: "#B6B6B6", textAlign: 'start' }} key={idx}>{th}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {tableBody?.map((row, i) => (
                                <tr key={i}>
                                    {row.map((cell, j) => {
                                        // Check if cell value looks like an image URL - completely generic approach
                                        const isImageColumn = cell && typeof cell === 'string' && (cell.includes('.png') || cell.includes('.jpg') || cell.includes('.jpeg') || cell.includes('.gif') || cell.includes('.svg') || cell.includes('http') || cell.includes('data:image'));
                                        console.log(`Column ${j}: ${tableHeadings[j]}, isImageColumn: ${isImageColumn}, cell: ${cell}`);
                                        return (
                                            <td key={j} className={j === 0 && sticky ? 'sticky-column' : ''} style={{ color: "#718096", verticalAlign: 'middle', textAlign: 'start' }}>
                                                {isImageColumn && cell ? (
                                                    <img src={cell} alt="App Icon" style={{ width: '40px', height: '40px', borderRadius: '6px', objectFit: 'contain' }} onError={(e) => { e.target.style.display = 'none'; }} />
                                                ) : (
                                                    cell
                                                )}
                                            </td>
                                        );
                                    })}
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>
            ) : (
                <div className="text-center p-3" style={{ color: "#718096" }}>
                    No Data Available
                </div>
            )}
        </>
    );
};

export default DashboardTable;
